import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// components
import PlusIcon from '@icons/PlusIcon';
import { ButtonNoStyles } from '@styled';

// functionality
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import fonts from '@general/fonts';

const CtaTextStyled = styled(ButtonNoStyles)`
    color: ${colors.azure};
    font-family: ${fonts.sans};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.31px;
    line-height: 20px;
    margin-right: 32px;
    text-align: left;

    @media ${mediaQueries.md} {
        font-size: 18px;
        line-height: 25px;
        margin-right: 0;
    }
`;

const CartUpsell = ({ text, onClick }) => {
    return (
        <div className="flex justify-between">
            <CtaTextStyled onClick={() => onClick()}>{text}</CtaTextStyled>
            <ButtonNoStyles onClick={() => onClick()}>
                <PlusIcon color={colors.azure} />
            </ButtonNoStyles>
        </div>
    );
};

CartUpsell.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default CartUpsell;
